import { gql } from "@apollo/client"
import {
  TransitionPaymentsGroupStateInput,
  TransitionPaymentsGroupStatePayload,
} from "@oysterhr/schema"

import { useMutation, InjectedOptions } from "@oysterhr/core"

export const TRANSITION_INVOICES_BATCH_MUTATION = gql`
  mutation TransitionPaymentsGroupState(
    $paymentsGroupId: ID!
    $eventTransition: PaymentsGroupStateEvent!
    $wireSentAt: ISO8601DateTime
    $paidAt: ISO8601DateTime
  ) {
    transitionPaymentsGroupState(
      input: {
        paymentsGroupId: $paymentsGroupId
        eventTransition: $eventTransition
        wireSentAt: $wireSentAt
        paidAt: $paidAt
      }
    ) {
      paymentsGroup {
        id
        state
        wireSentAt
        paidAt
        invoiceErrors {
          metadata {
            totalPages
            totalCount
            currentPage
            limitValue
          }
        }
      }
      errors
    }
  }
`

export const useTransitionInvoicesBatch = (
  options?: InjectedOptions<
    { transitionPaymentsGroupState: TransitionPaymentsGroupStatePayload },
    TransitionPaymentsGroupStateInput
  >,
) => useMutation(TRANSITION_INVOICES_BATCH_MUTATION, options)
